module.exports = __webpack_public_path__ + "static/img/icon2.218eb74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/icon2.png
// module id = E7CC
// module chunks = 3